import { render, staticRenderFns } from "./_positionTakingLog.vue?vue&type=template&id=2333b55d&lang=pug&"
import script from "./_positionTakingLog.vue?vue&type=script&lang=js&"
export * from "./_positionTakingLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports